import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Bestsellers } from '../components/Bestsellers';
import { ProductLines } from '../components/ProductLines';
import { WhyChamaleon } from '../components/WhyChamaleon';
import { PartnerCTA } from '../components/PartnerCTA';
import { NewsSection } from '../components/NewsSection';
import { ContactForm } from '../components/ContactForm';
import { MobileApp } from '../components/MobileApp';
import { Footer } from '../components/Footer';
type Language = 'ua' | 'en';
export function HomePage() {
  const [language, setLanguage] = useState<Language>('en');
  return <div className="min-h-screen bg-chamaleon-black" data-id="element-359">
      <Header language={language} onLanguageChange={setLanguage} data-id="element-360" />
      <main data-id="element-361">
        <Hero language={language} data-id="element-362" />
        <ProductLines language={language} titleOverride="Product Catalog 1" variant="static" data-id="element-363" />
        <ProductLines language={language} titleOverride="Product Catalog 2" variant="animated" data-id="element-364" />
        <ProductLines language={language} titleOverride="Product Catalog 3" variant="animated" data-id="element-365" />
        <MobileApp language={language} data-id="element-366" />
        <Bestsellers language={language} data-id="element-367" />
        <WhyChamaleon language={language} data-id="element-368" />
        <PartnerCTA language={language} data-id="element-369" />
        <NewsSection language={language} data-id="element-370" />
        <ContactForm language={language} data-id="element-371" />
      </main>
      <Footer language={language} onLanguageChange={setLanguage} data-id="element-372" />
    </div>;
}